export default __webpack_public_path__ + "static/Met-2fa398da1bdef73281161af07b421094.png";